import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import contestApi from '@/api/contest'

export default {
    name: 'MyContestZoneSetting',
    components: {
        AppBar,
        AppBarSpace,
    },
    data() {
        return {
            contestId: this.$route.params.contestId,
            info: null,
            judgeList: null,
            showPop: false,
            currentSelectedType:null,
            result: [],
            showTypePicker:false,
            columns: [{text:'重量',type:'ZL'},{text:'尾数',type: 'WS'}],
            currentType:null,
            currentSubIndex:0
        }
    },
    created() {
        this.getPageInfo()
        this.getAllJudge()
    },
    methods: {
        async getPageInfo() {
            try {
                const infoTemp = await contestApi.getSubareaAndJudge(this.contestId)
                if (infoTemp.secondJudge === '' || infoTemp.secondJudge === null || infoTemp.secondJudge === 'undefined'){
                    infoTemp.secondJudge = []
                }else {
                    infoTemp.secondJudge = JSON.parse(infoTemp.secondJudge)
                }

                if (infoTemp.subareaJudge === '' || infoTemp.subareaJudge === null || infoTemp.subareaJudge === 'undefined'){
                    infoTemp.subareaJudge = []
                }else {
                    infoTemp.subareaJudge = JSON.parse(infoTemp.subareaJudge)
                }
                this.info = infoTemp;
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        async getAllJudge(){
            try {
                this.judgeList = await contestApi.getAllJudge(this.contestId)
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        async saveSetting(){
            this.$toast.loading()
            try {
                // eslint-disable-next-line no-unused-vars
                let result = await contestApi.saveSubareaAndJudge(this.contestId,JSON.stringify(this.info.secondJudge),this.info.sessionCount,this.info.sortType,this.info.subareaCount,JSON.stringify(this.info.subareaJudge))
                this.$toast.success("设置成功")
                this.$router.go(-1);
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        toggle(index) {
            this.$refs.checkboxes[index].toggle();
        },
        selectSubJudge(index){
            this.showPop = true
            this.currentSelectedType = 'Sub'
            this.currentSubIndex = index
        },
        selectSecondJudge(){
            this.showPop = true
            this.currentSelectedType = 'Second'
        },
        sureJudgeSelect(){
            if(this.currentSelectedType === 'Second'){
                this.info.secondJudge = this.result
            }else if(this.currentSelectedType === 'Sub'){
                this.$set(this.info.subareaJudge,this.currentSubIndex,this.result)
            }
            this.result = []
            this.showPop = false
        },
        onTypeSelected(){
            this.$refs.typePicker.confirm();
        },
        onConfirm(value){
            this.info.sortType = value.type;
            this.showTypePicker = false
        },
        subareaSetting(){
            if(this.info.subareaCount && Number(this.info.subareaCount) > 0){
                const tempJudge = [];
                for (let i = 0; i < this.info.subareaCount; i++) {
                    tempJudge.push([])
                }
                this.info.subareaJudge = tempJudge;
            }else {
                this.info.subareaJudge = [];
            }
        }
    }
}
